import makeStyles from '@mui/styles/makeStyles';
const governmentEVRebateStyles = makeStyles(() => ({
    container: {
        marginLeft: '20px',
    },
}), {
    name: 'Common_GovernmentEVRebate',
});
export default governmentEVRebateStyles;
//# sourceMappingURL=governmentEVRebate.styles.js.map